import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Table from '../../components/Table/Table'
import { estimateTableCols } from '../../helpers/tableUtils'

import { getInitialEstimateFilters } from '../../helpers/requestsFilters'
import FilterModal from '../../components/FilterModal/FilterModal'
import useRequest from '../../hooks/useRequest'
import useAuth from '../../hooks/useAuth'

const EstimateTable = ({
    data,
    onFilter,
    title,
    subtitle,
    isInCard,
    filtersLIst,
    isCreateRequest = false,
    ...otherProps
}) => {
    const [filterOpen, setFilterOpen] = useState(false)
    const [hasActiveFilters, setHasActiveFilters] = useState(false)

    const { locations, estimateFilters } = useRequest()
    const { user } = useAuth()
    const locPrefs = user?.locationPreferences

    const allEstimateFilters = filtersLIst
        ? filtersLIst
        : getInitialEstimateFilters(locPrefs, locations)
    const hasStoreEstimateFilters = estimateFilters?.length > 0
    const estimateFiltersToUse = hasStoreEstimateFilters
        ? estimateFilters
        : allEstimateFilters

    const allFiltersIsReady = estimateFiltersToUse?.find(
        item => item?.filters?.length > 0 && item?.filterGrupName == 'Location',
    )

    useEffect(() => {
        if (estimateFiltersToUse) {
            const hasActiveFilters = estimateFiltersToUse.some(group =>
                group.filters.some(filter => filter.checked),
            )
            setHasActiveFilters(hasActiveFilters)
        }
    }, [estimateFiltersToUse])

    return (
        <Table
            isInCard={isInCard}
            selectable={false}
            hasSearch={true}
            columns={estimateTableCols}
            data={data}
            totalResults={data?.length}
            type="scroll"
            headerTitle={title}
            headerSubtitle={subtitle}
            searchPlaceholder="Search Estimate"
            actions={[
                !isCreateRequest && allFiltersIsReady && (
                    <FilterModal
                        isSmallScreen
                        key="filterModal"
                        filtersGroup={estimateFiltersToUse}
                        open={filterOpen}
                        setOpen={setFilterOpen}
                        onFilter={onFilter}
                        data={data}
                    />
                ),
            ]}
            searchFields={[
                'name',
                'workOrderName',
                'status',
                'assetNameNormalKey',
                'submittedDate',
                'validUntil',
                'estimateDetails',
                'validUntilPrettyDate',
                'submittedPrettyDate',
            ]}
            hasActiveFilters={hasActiveFilters}
            {...otherProps}
        />
    )
}

EstimateTable.propTypes = {
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
    onFilter: PropTypes.oneOfType([PropTypes.func, PropTypes.any]),
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
    isInCard: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
    getAllRequests: PropTypes.bool,
    filtersLIst: PropTypes.array,
    isCreateRequest: PropTypes.bool,
}

export default EstimateTable
